import axios from "axios";

const runtimeOrigin =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";
const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
const BACKEND_URL = (configuredBackendUrl || runtimeOrigin).replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;
export const SOCKET_PATH = "/api/socketio";
export const SOCKET_URL = BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createRoom = async (data) => (await api.post("/rooms", data)).data;
export const getRoom = async (code) => (await api.get(`/rooms/${code}`)).data;
export const joinRoom = async (code, data) =>
  (await api.post(`/rooms/${code}/join`, data)).data;
export const searchKaraoke = async (q, signal) =>
  (await api.get("/search", { params: { q, max_results: 20 }, signal })).data;
export const searchYouTube = async (q, signal) =>
  (await api.get("/songs/search-youtube", { params: { q, max_results: 20 }, signal })).data;
export const getQueue = async (code) => (await api.get(`/queue/${code}`)).data;
export const addToQueue = async (code, data) =>
  (await api.post(`/queue/${code}`, data)).data;
export const addToQueueAsHost = async (code, song, host_token, host_nickname = "Host") =>
  (await api.post(`/queue/${code}`, {
    ...song,
    requested_by: "host",
    requested_by_name: host_nickname,
    host_token,
  })).data;
export const removeFromQueue = async (code, id, params) =>
  (await api.delete(`/queue/${code}/${id}`, { params })).data;
export const reorderQueue = async (code, queue_ids, host_token) =>
  (await api.patch(`/queue/${code}/reorder`, { queue_ids, host_token })).data;
export const getPopularSearches = async (limit = 8) =>
  (await api.get("/search/popular", { params: { limit } })).data;
export const getLyrics = async (title, signal) =>
  (await api.get("/lyrics", { params: { title }, signal })).data;
export const getAdminAnalytics = async (limit = 5) =>
  (await api.get("/admin/analytics", { params: { limit }, withCredentials: true })).data;
export const getAdminRooms = async () =>
  (await api.get("/admin/rooms", { withCredentials: true })).data;
export const getSearchAnalytics = async ({ limit = 10, period = "lifetime" } = {}) =>
  (
    await api.get("/admin/analytics", {
      params: { limit, period },
      withCredentials: true,
    })
  ).data;
export const getAdminSongs = async ({
  q = "",
  page = 1,
  page_size = 20,
  sort_by = "updatedAt",
  sort_order = "desc",
  include_hidden = true,
} = {}) =>
  (
    await api.get("/admin/songs", {
      params: { q, page, page_size, sort_by, sort_order, include_hidden },
      withCredentials: true,
    })
  ).data;
export const getAdminSong = async (videoId) =>
  (await api.get(`/admin/songs/${videoId}`, { withCredentials: true })).data;
export const updateAdminSong = async (videoId, data) =>
  (await api.patch(`/admin/songs/${videoId}`, data, { withCredentials: true })).data;
export const hideAdminSong = async (videoId) =>
  (await api.post(`/admin/songs/${videoId}/hide`, {}, { withCredentials: true })).data;
export const unhideAdminSong = async (videoId) =>
  (await api.post(`/admin/songs/${videoId}/unhide`, {}, { withCredentials: true })).data;
export const verifyAdminSong = async (videoId) =>
  (await api.post(`/admin/songs/${videoId}/verify`, {}, { withCredentials: true })).data;
export const closeAdminRoom = async (roomCode) =>
  (await api.post(`/admin/rooms/${roomCode}/close`, {}, { withCredentials: true })).data;
export const developerLogin = async (data) =>
  (await api.post("/developer/login", data, { withCredentials: true })).data;
export const developerLogout = async () =>
  (await api.post("/developer/logout", {}, { withCredentials: true })).data;
export const getDeveloperSession = async () =>
  (await api.get("/developer/me", { withCredentials: true })).data;
export const kickGuest = async (code, guest_id, host_token) =>
  (await api.post(`/rooms/${code}/kick`, { guest_id, host_token })).data;
export const banGuest = async (code, guest_id, host_token) =>
  (await api.post(`/rooms/${code}/ban`, { guest_id, host_token })).data;
